/**
 * @param  {"auth"} {name
 * @param  {defaultState} initialState
 * @param  {{login:(state} reducers
 */
import { createSlice } from "@reduxjs/toolkit";

const defaultState = {
  question: "",
  answers: [],
  question_id: "",
  modalOpened: false,
  currentSubject: "",
};

let applicationSlice = createSlice({
  name: "application",
  initialState: defaultState,
  reducers: {
    setAnswers: (state, action) => {
      state.answers = action.payload;
    },
    setCurrentSubject: (state, action) => {
      state.currentSubject = action.payload;
    },
    setModalState: (state, action) => {
      state.modalOpened = action.payload;
    },
    setQuestion: (state, action) => {
      state.question = action.payload;
    },
    setQuestionID: (state, action) => {
      state.question_id = action.payload;
    },
  },
});

/**
 *
 * @param {{application: defaultState}} state
 */
export const getAnswers = ({ application: state }) => state.answers;
export const getQuestion = ({ application: state }) => state.question;
export const getCurrentSubject = ({ application: state }) =>
  state.currentSubject;
export const getQuestionID = ({ application: state }) => state.question_id;
export const getModalState = ({ application: state }) => state.modalOpened;

export const {
  setAnswers,
  setQuestion,
  setModalState,
  setQuestionID,
  setCurrentSubject,
} = applicationSlice.actions;

export default applicationSlice.reducer;
